import clsx from "clsx"
import { AnimatePresence, motion } from "framer-motion"
import React, { type ReactNode } from "react"
import { Animations, type AnimationType } from "@/shared/utils/animations.ts"
import "./style.scss"
import { Close } from "@/shared/components/ui/icons"

interface ModalProps {
  show: boolean
  onClose: VoidFunction
  title: ReactNode
  animationType?: AnimationType
  children: ReactNode
  classNames?: {
    overlay?: string
    modal?: string
    content?: string
  }
}

export class Modal extends React.Component<ModalProps> {
  // overlayRef: React.RefObject<HTMLDivElement> = React.createRef()
  componentDidMount() {
    window.addEventListener("keydown", this.handleKeyDown)
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown)
  }

  handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      this.props.onClose()
    }
  }

  render() {
    const { show, onClose, animationType = "scaleIn", classNames } = this.props
    return (
      <AnimatePresence>
        {show && (
          <motion.div
            transition={{ duration: 0.2 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className={clsx("modal-overlay", classNames?.overlay)}
            onClick={onClose}
          >
            <motion.div
              transition={{ duration: 0.2, ease: "easeInOut" }}
              {...Animations(animationType)}
              className={clsx("modal-inner", classNames?.modal)}
              onClick={e => e.stopPropagation()}
            >
              <div className="modal-inner__title">
                <span>{this.props.title}</span>
                <div className="modal-inner__close" onClick={onClose}>
                  <Close size={20} />
                </div>
              </div>
              <div className={clsx("modal-inner__content", classNames?.content)}>{this.props.children}</div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    )
  }
}
